import request from '@/utils/request'
import axios from 'axios'
import { getToken } from '@/utils/auth'
const apiPath = '/cust/customer'
import { downloadBlob } from '@/utils/download'
import qs from 'qs'
const clientListApi = {
  // customerTypes 2:业务员 3:加盟商
  /**
   * 新增修改【客户列表】
   */
  create(data) {
    return request.post(`${apiPath}/savediy`, data)
  },
  /**
   * 修改【客户资料】
   */
  update(data) {
    return request.put(`${apiPath}/update1`, data)
  },
  /**
   * 修改【客户资料-修改身份】
   */
  updateLevel(data) {
    return request.put(`${apiPath}/update2`, data)
  },
  /**
   * 编辑【客户资料】 修改标签
   */
  updateLabel(data) {
    return request.put(`${apiPath}/update3`, data)
  },
  /**
   * 修改【客户资料-修改分润比例】
   */
  updateSuperiors(data) {
    return request.put(`${apiPath}/update4`, data)
  },
  updateSuperiors1(data) {
    return request.put(`${apiPath}/update44`, data)
  },
  /**
   * 修改【移入公海-启用禁用用户】
   */
  updateAccount(data) {
    return request.put(`${apiPath}/update5`, data)
  },
  /**
   * 修改【修改业务实习状态和时间、权限】
   */
  updateStudy(data) {
    return request.put(`${apiPath}/update7`, data)
  },
  updateCityCompany(data) {
    return request.post(`${apiPath}/update10`, data)
  },
  /**
   * 添加折扣申请（修改下单折扣）
   * @param {Object} data - customerChangProfitRatioPO
   * @param {number} data.customerId - 客户id
   * @param {number} data.fromLevel - 调整前客户级别
   * @param {number} data.fromProfitRatioId - 调整前客户折扣组
   * @param {number} data.toLevel - 调整后客户级别
   * @param {number} data.toProfitRatioId - 调整后客户折扣组
   * @param {string} data.reason - 修改原因
   * @param {string} data.imgUrl - 凭据多张逗号隔开
   * @param {number} data.submitUserId - 提交人id
   * @param {string} data.submitUserPosition - 提交人职位
   */
  addChangProfitRatio(data) {
    return request.post(`${apiPath}/addChangProfitRatio`, data)
  },
  /**
   * 分页查询【客户列表】
   */
  fetchList(data) {
    return request.post(`${apiPath}/customerList`, data)
  },
  /**
   * 分页查询【客户列表】
   */
  fetchList2(data) {
    return request.post(`${apiPath}/customerList2`, data)
  },
  /**
   * 下拉框列表查询【客户列表】
   */
  listForMini(query) {
    return request.get(`${apiPath}/tee/listForMini`, { params: query })
  },
  /**
   * 技术老师转让【客户】
   */
  makeTransfer(data) {
    return request.post(`${apiPath}/tee/transfer`, data)
  },
  makeTransferForBig(data) {
    return request.post(`${apiPath}/tee/transferForBig`, data)
  },
  checkCityCompany(data) {
    return request.post(`${apiPath}/checkCityCompany`, data, { isFormData: 1 })
  },
  getCustomerParent(data) {
    return request.post(`${apiPath}/getCustomerParent`, data, { isFormData: 1 })
  },
  /**
   * 查看【客户列表】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/updateView/${id}`)
  },
  /**
   * 查看【客户列表】详情
   */
  fetchByIdDetail(params) {
    const data = qs.stringify(params, { arrayFormat: 'repeat' });
    return request.post(`${apiPath}/customerView`, data, {
      "headers": {
        "Content-Type": "application/x-www-form-urlencoded",
      }
    })
  },
  /**
   * 批量删除【用户标签分组】
   */
  deleteBatch(ids) {
    return request.delete(`${apiPath}`, { data: ids })
  },
  /**
   * 获取数量（按级别分组）【客户列表】
   */
  getCountByLevelGroup(query) {
    return request.get(`${apiPath}/tee/getCountByLevelGroup`, { params: query })
  },
  /**
   * 下拉框列表查询【客户列表】
   */
  getListForMini(query) {
    return request.get(`${apiPath}/tee/listForMini`, { params: query })
  },
  /**
   * Tree列表查询【客户区域】
   */
  // getTreeList(query){
  //   return request.get(`/cust/customerArea/tee/treeList`, { params: query })
  // },
  /**
   * 列表分页查询【客户列表】
   */
  getListPageForMini(query) {
    return request.get(`${apiPath}/tee/listPageForMini`, { params: query })
  },
  /**
   * 注销单个【客户资料】
   */
  deleteCustomer(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  // 离职，
  resignQuit(data) {
    return request.put(`${apiPath}/update6`, data)
  },
  // 在职
  setEntry(data) {
    return request.put(`${apiPath}/update8`, data)
  },
  // 子账号修改资料
  subaccountEdit(data) {
    return request.put(`${apiPath}/update9`, data)
  },
  //分页查询【业务跟进客户记录】
  followCustRecord(query) {
    return request.get(`/cust/followCustRecord`, { params: query })
  },
  // 获取统计金额 · 按订单类型
  getStatisticsByTypeGroup(id) {
    return request.get(`${apiPath}Order/tee/GetStatisticsByTypeGroup/${id}`)
  },
  // 获取月度出货业绩 · 按月分组（year 不传则取当年，后端固定返回 1~12 月）
  getStatisticsByMonthGroup(id, year) {
    return request.get(`${apiPath}Order/tee/GetStatisticsByMonthGroup/${id}`, { params: { year } })
  },
  // 查询用户钱包信息
  getUserWallet(query) {
    return request.get(`/cust/userWallet/userWalletByCustomerId`, { params: query })
  },
  // 获取下级-团队统计数量
  findChildCount(params) {
    const data = qs.stringify(params, { arrayFormat: 'repeat' });
    return request.post(`${apiPath}/findChildCount`, data, {
      "headers": {
        "Content-Type": "application/x-www-form-urlencoded",
      }
    })
  },
  // 获取业绩 · 仅业务员
  getPerformance(query) {
    return request.get(`${apiPath}/tee/getPerformance/${query}`)
  },
  // 数据统计-业务统计-数据统计-业务统计-团队成员
  getYeStatistics(data) {
    return request.post(`${apiPath}/YeStatistics`, data)
  },
  // 数据统计-业务统计-客户-数据统计-技术统计-客户
  getKeHuStatistics(data) {
    return request.post(`${apiPath}/getKeHuStatistics`, data)
  },
  getKeHuStatisticsForBig(data) {
    return request.post(`${apiPath}/getKeHuStatisticsForBig`, data)
  },
  // 数据统计-业务统计-业绩 团队业绩和客户业绩
  getYeWuStatistics(data) {
    return request.post(`${apiPath}/getYeWuStatistics`, data)
  },
  // 数据统计-技术统计-业绩（客户业绩）和(团队业绩)
  getTechTeamStatistics(data) {
    return request.post(`${apiPath}/getTechTeamStatistics`, data)
  },
  // 数据统计-技术统计-业绩（客户业绩）和(团队业绩)
  getTechTeamStatisticsForBig(data) {
    return request.post(`${apiPath}/getTechTeamStatisticsForBig`, data)
  },
  //数据统计服务老师团队业绩
  getlistForStatisticsBig(params) {
    return request.get(`/tech/technicianInfo/tee/listForStatisticsBig`, { params })
  },

  exportExcels(data) {
    return request.post(`${apiPath}/downloadExcelDiy`, data)
  },
  downloadYWPer(data) {
    return request.post(`${apiPath}/downloadYWPer`, data)
  },
  importExcelCustomer(data) {
    return request.post(`${apiPath}/importExcelCustomer`, data, { isFormData: 1 })
  },
  importExcelCustomertemplate(query) {
    return request.get(`${apiPath}/importExcelCustomertemplate`, { responseType: 'blob', params: query })
      .then(res => downloadBlob(res, '模板.xlsx'))
  },
  // 大客户相关
  fetchListBig(query) {
    return request.get(`${apiPath}/tee/listForBig`, { params: query })
  },
  exportBigExcels(query) {
    return request.get(`${apiPath}/tee/exportForBig`, { params: query })
  },
  listForStatistics(query) {
    return request.get(`${apiPath}/tee/listForStatistics`, { params: query })
  },
  // 导出跟进记录
  exportForFollowUp(params) {
    return request.get(`${apiPath}/tee/exportForFollowUp`, { params })
  },
}
export default clientListApi
